import ContractsContainer from './ContractsContainer';

export default ContractsContainer;
